export default __webpack_public_path__ + "static/media/carou5.3dcb84c8.jpg";